import { render, staticRenderFns } from "./asdcjz.vue?vue&type=template&id=049ce06c&"
import script from "./asdcjz.vue?vue&type=script&lang=js&"
export * from "./asdcjz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports